<app-twilio-call-viewer
  [remoteUser]="remoteUser"
>
</app-twilio-call-viewer>
